export const COMPANY_NAME = "Krabby Patty LLC";
export const COMPANY_SHORT = "Krabby Patty";
export const COMPANY_INITIALS = "KP";
export const COMPANY_ADDRESS_FULL = "550 S Hill St #1420, Los Angeles, CA 90013";
export const COMPANY_LOCATION = "Los Angeles, CA";
export const COMPANY_REGION = "Los Angeles County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=550%20S%20Hill%20St%20%231420%2C%20Los%20Angeles%2C%20CA%2090013";
export const ABOUT_IMAGE_URL = "/about-los-angeles.png";

export const PROFILE_FACTS = [
  { "label": "Organization", "value": "Limited liability company" },
  { "label": "Location", "value": "Los Angeles, CA" },
  { "label": "Public filing", "value": "Established 2025" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Krabby Patty LLC" },
  { "label": "Location", "value": "Los Angeles, CA" },
  { "label": "Principal office", "value": "550 S Hill St #1420, Los Angeles, CA 90013" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Public profile", "body": "A concise directory profile based on publicly filed organization information." },
  { "icon": "✦", "title": "California LLC", "body": "Organized as a California limited liability company." },
  { "icon": "✿", "title": "Principal office", "body": "Public filing lists a principal office in downtown Los Angeles." },
  { "icon": "❍", "title": "General purpose", "body": "The filing describes a lawful-business purpose under California law." },
];
